/*

Window Types

A - general use
B - height variants for floor height changes
G - gable end windows
T - transoms
K - kitchens (higher sill height to clear the counter)
C - larger with lower sill height
D - TODO:
V - vents

NO - removing windows in change sets and overrides

*/

// standard is hit 2" below 8' head height

export enum BuiltinWindowId {
  A1840 = "A1840",
  A2040 = "A2040",
  A2060 = "A2060",
  A2640 = "A2640",
  A3030 = "A3030",
  A4040 = "A4040",
  A2046 = "A2046",
  A71046 = "A71046",
  A2050 = "A2050",
  A2030 = "A2030",
  A2080 = "A2080",
  A2650 = "A2650",
  A2550 = "A2550",
  A3040 = "A3040",
  A3040_TEMP = "A3040_TEMP",
  A3046 = "A3046",
  A3050 = "A3050",
  A3050_TEMP = "A3050_TEMP",
  A3050_BRICK = "A3050_BRICK",
  A3850 = "A3850",
  A4050 = "A4050",
  A5050 = "A5050",
  A2860 = "A2860",
  A3060 = "A3060",
  A4060 = "A4060",
  A5060 = "A5060",
  A31080 = "A31080",
  A4080 = "A4080",
  A5080 = "A5080",
  A31090 = "A31090",
  A4090 = "A4090",
  A5090 = "A5090",
  TR13880 = "TR13880",
  TR13890 = "TR13890",
  TW2636 = "TW2636",
  TW2040 = "TW2040",
  TW2640 = "TW2640",
  TW2646 = "TW2646",
  TW2650 = "TW2650",
  TW3020 = "TW3020",
  TW3050 = "TW3050",
  TW3050_TEMP_HALF = "TW3050_TEMP_HALF",
  TW3060 = "TW3060",
  TW3080 = "TW3080",
  TW4080 = "TW4080",
  TR2020 = "TR2020",
  TR2030 = "TR2030",
  TR2640 = "TR2640",
  TR2650 = "TR2650",
  TR2660 = "TR2660",
  TR2050 = "TR2050",
  TR3050 = "TR3050",
  TR3060 = "TR3060",
  TR3080 = "TR3080",
  K1 = "K1",
  T1 = "T1",
  T2 = "T2",
  T2620 = "T2620",
  T3620 = "T3620",
  T3010 = "T3010",
  T4010 = "T4010",
  T5010 = "T5010",
  T6010 = "T6010",
  T8010 = "T8010",
  T2010 = "T2010",
  T2020 = "T2020",
  T6020 = "T6020",
  T2020_LOW = "T2020_LOW",
  TW2220 = "TW2220",
  G1620 = "G1620",
  G2020 = "G2020",
  G2030 = "G2030",
  G2436 = "G2436",
  G2040 = "G2040",
  G3040 = "G3040",
  G6630 = "G6630",
  S1 = "S1",
  S2 = "S2",
  SL1 = "SL1",
  D6020 = "D6020",
  V2020 = "V2020",
  V0808 = "V0808",
  V1 = "V1",
  V0912 = "V0912",
  V1220 = "V1220",
  V1020 = "V1020",
  V1620 = "V1620",
  V1824 = "V1824",
  D1 = "D1",
  NO = "NO",
  FS3050 = "FS3050",
}
